class Util {
    public static parseUriToString(uri: string): string {
        const splits: string[] = uri.split("://");
        if (splits.length > 1) {
            return splits[1];
        }
        return uri;
    }

    public static parseContentFileUri(uri: string, storageUrl: string): string {
        if (storageUrl.endsWith("/")) {
            storageUrl = storageUrl.slice(0, -1);
        }
        return `${storageUrl}/contentFiles/${Util.parseUriToString(uri)}`;
    }

    public static parseAssetToAbsoluteUrl(uri: string, storageUrl: string): string {
        if (storageUrl.endsWith("/")) {
            storageUrl = storageUrl.slice(0, -1);
        }
        return `${storageUrl}/assetFolders/${Util.parseUriToString(uri)}`;
    }
}

export default Util;
